export default "__VITE_ASSET__B7y90xvK__"